// Generated by npm run wfdl:compile-grammar
// http://github.com/Hardmath123/nearley
(function () {
  function id(x) {
    return x[0];
  }

  const lexer = require('./lexer').default;
  const w = require('@packages/systems/wfdl');
  const ast = require('@packages/systems/wfdl-ast');
  const wq = require('@packages/systems/wfdl-Qualified');

  const id2 = ([[x]]) => x;
  const id3 = ([[[x]]]) => x;

  const {systemKeys} = require('@packages/systems/wfdl/DataTypeDefinition');

  function applyAttributes(attributes, type) {
    if (!attributes) {
      return type;
    }

    const {
      hasSystemAttributes,
      systemAttributes,
      hasMetaAttributes,
      metaAttributes,
    } = attributes;

    let result = type;

    if (hasSystemAttributes) {
      result = w.withSystem(systemAttributes, result);
    }

    if (hasMetaAttributes) {
      result = w.withMeta(metaAttributes, result);
    }

    return result;
  }

  const primitiveOf = (value) => {
    switch (value) {
      case 'Boolean':
        return ast.TBoolean;
      case 'Number':
        return ast.TNumber;
      case 'Text':
        return ast.TText;
      case 'Element':
        return ast.TElement;
      case 'RowEmpty':
        return ast.TRowEmpty;
      case 'List':
        return ast.tyList;
      case 'Record':
        return ast.TTypeConstructor(ast.recordTypeName);
      default: {
        throw new Error('Unknown primitive type: ' + value);
      }
    }
  };

  function generateFieldsAndTail(pairs, maybeTail) {
    const fields = {};
    if (pairs) {
      for (const pair of pairs) {
        if (!pair) continue;
        fields[pair[0]] = pair[1];
      }
    }

    let tail = null;

    if (maybeTail) {
      tail = maybeTail[0][0];
      if (tail[0].type === 'ellipsis') {
        // ...<tvar>
        tail = tail[1];
      } else {
        // tpair
        fields[tail[0]] = tail[1];
        tail = null;
      }
    }

    return {fields, tail};
  }
  var grammar = {
    Lexer: lexer,
    ParserRules: [
      {
        name: 'ident',
        symbols: [lexer.has('word') ? {type: 'word'} : word],
        postprocess: ([name]) => name.value,
      },
      {
        name: 'string',
        symbols: [lexer.has('string') ? {type: 'string'} : string],
        postprocess: ([token]) => JSON.parse(token.value),
      },
      {
        name: 'number',
        symbols: [lexer.has('number') ? {type: 'number'} : number],
        postprocess: ([token]) => JSON.parse(token.value),
      },
      {
        name: 'bool',
        symbols: [lexer.has('bool') ? {type: 'bool'} : bool],
        postprocess: ([token]) => JSON.parse(token.value),
      },
      {name: '_$ebnf$1', symbols: []},
      {
        name: '_$ebnf$1$subexpression$1',
        symbols: [lexer.has('WS') ? {type: 'WS'} : WS],
      },
      {
        name: '_$ebnf$1$subexpression$1',
        symbols: [lexer.has('comment') ? {type: 'comment'} : comment],
      },
      {
        name: '_$ebnf$1',
        symbols: ['_$ebnf$1', '_$ebnf$1$subexpression$1'],
        postprocess: function arrpush(d) {
          return d[0].concat([d[1]]);
        },
      },
      {name: '_', symbols: ['_$ebnf$1'], postprocess: (_) => null},
      {
        name: '__',
        symbols: [lexer.has('WS') ? {type: 'WS'} : WS],
        postprocess: (_) => null,
      },
      {name: 'typeMain$subexpression$1', symbols: ['_', 'type', '_']},
      {
        name: 'typeMain',
        symbols: ['typeMain$subexpression$1'],
        postprocess: ([[_, x]]) => x,
      },
      {name: 'type$subexpression$1', symbols: ['_type']},
      {name: 'type$subexpression$1', symbols: ['wrappedType']},
      {name: 'type', symbols: ['type$subexpression$1'], postprocess: id2},
      {
        name: 'wrappedType',
        symbols: [{literal: '('}, '_', 'type', '_', {literal: ')'}],
        postprocess: ([, , type]) => type,
      },
      {name: '_type$ebnf$1', symbols: ['attributeSet'], postprocess: id},
      {
        name: '_type$ebnf$1',
        symbols: [],
        postprocess: function (d) {
          return null;
        },
      },
      {name: '_type$subexpression$1', symbols: ['nonFuncType']},
      {name: '_type$subexpression$1', symbols: ['tfunc']},
      {
        name: '_type',
        symbols: ['_type$ebnf$1', '_type$subexpression$1'],
        postprocess: ([attributes, [type]]) =>
          applyAttributes(attributes, type),
      },
      {name: 'nonFuncType$subexpression$1', symbols: ['primitive']},
      {name: 'nonFuncType$subexpression$1', symbols: ['tlist']},
      {name: 'nonFuncType$subexpression$1', symbols: ['rowType']},
      {name: 'nonFuncType$subexpression$1', symbols: ['trecord']},
      {name: 'nonFuncType$subexpression$1', symbols: ['tunion']},
      {name: 'nonFuncType$subexpression$1', symbols: ['tenum']},
      {name: 'nonFuncType$subexpression$1', symbols: ['tvar']},
      {name: 'nonFuncType$subexpression$1', symbols: ['generic']},
      {name: 'nonFuncType$subexpression$1', symbols: ['tconstructor']},
      {name: 'nonFuncType$subexpression$1', symbols: ['tapplication']},
      {
        name: 'nonFuncType',
        symbols: ['nonFuncType$subexpression$1'],
        postprocess: id2,
      },
      {
        name: 'attributeSet$ebnf$1$subexpression$1',
        symbols: ['attribute', '_'],
      },
      {
        name: 'attributeSet$ebnf$1',
        symbols: ['attributeSet$ebnf$1$subexpression$1'],
      },
      {
        name: 'attributeSet$ebnf$1$subexpression$2',
        symbols: ['attribute', '_'],
      },
      {
        name: 'attributeSet$ebnf$1',
        symbols: ['attributeSet$ebnf$1', 'attributeSet$ebnf$1$subexpression$2'],
        postprocess: function arrpush(d) {
          return d[0].concat([d[1]]);
        },
      },
      {
        name: 'attributeSet',
        symbols: ['attributeSet$ebnf$1'],
        postprocess: ([attributes]) => {
          // Sort system and meta attributes
          let systemAttributes = {};
          let hasSystemAttributes = false;
          let metaAttributes = {};
          let hasMetaAttributes = false;

          for (let i = 0; i < attributes.length; i++) {
            const [attribute] = attributes[i];

            if (!attribute) {
              continue;
            }

            for (const [key, value] of Object.entries(attribute)) {
              if (systemKeys.has(key)) {
                systemAttributes[key] = value;
                hasSystemAttributes = true;
              } else {
                metaAttributes[key] = value;
                hasMetaAttributes = true;
              }
            }
          }

          return {
            hasSystemAttributes,
            systemAttributes,
            hasMetaAttributes,
            metaAttributes,
          };
        },
      },
      {name: 'attribute$ebnf$1', symbols: ['attributeArgs'], postprocess: id},
      {
        name: 'attribute$ebnf$1',
        symbols: [],
        postprocess: function (d) {
          return null;
        },
      },
      {
        name: 'attribute',
        symbols: [{literal: '@'}, 'ident', 'attribute$ebnf$1'],
        postprocess: ([at, key, arg]) => {
          let value;
          if (arg === undefined || arg === null) {
            value = true;
          } else {
            value = arg;
          }

          return {
            [key]: value,
          };
        },
      },
      {
        name: 'attributeArgs',
        symbols: [{literal: '('}, '_', 'attributeArg', '_', {literal: ')'}],
        postprocess: ([lparen, _, arg]) => arg,
      },
      {name: 'attributeArg', symbols: ['number'], postprocess: id},
      {name: 'attributeArg', symbols: ['string'], postprocess: id},
      {name: 'attributeArg', symbols: ['bool'], postprocess: id},
      {name: 'attributeArg', symbols: ['jsonArray'], postprocess: id},
      {name: 'attributeArg', symbols: ['jsonObject'], postprocess: id},
      {name: 'jsonArray$ebnf$1', symbols: ['jsonArrayItems'], postprocess: id},
      {
        name: 'jsonArray$ebnf$1',
        symbols: [],
        postprocess: function (d) {
          return null;
        },
      },
      {
        name: 'jsonArray',
        symbols: [{literal: '['}, '_', 'jsonArray$ebnf$1', {literal: ']'}],
        postprocess: ([_lb, _ws, items]) => items ?? [],
      },
      {name: 'jsonArrayItems$ebnf$1', symbols: []},
      {
        name: 'jsonArrayItems$ebnf$1$subexpression$1',
        symbols: ['jsonValue', '_', {literal: ','}, '_'],
      },
      {
        name: 'jsonArrayItems$ebnf$1',
        symbols: [
          'jsonArrayItems$ebnf$1',
          'jsonArrayItems$ebnf$1$subexpression$1',
        ],
        postprocess: function arrpush(d) {
          return d[0].concat([d[1]]);
        },
      },
      {
        name: 'jsonArrayItems',
        symbols: ['jsonArrayItems$ebnf$1', 'jsonValue'],
        postprocess: ([pairs, last]) => [...pairs.map(([v]) => v), last],
      },
      {
        name: 'jsonObject$ebnf$1',
        symbols: ['jsonObjectItems'],
        postprocess: id,
      },
      {
        name: 'jsonObject$ebnf$1',
        symbols: [],
        postprocess: function (d) {
          return null;
        },
      },
      {
        name: 'jsonObject',
        symbols: [{literal: '{'}, '_', 'jsonObject$ebnf$1', {literal: '}'}],
        postprocess: ([_lb, _ws, items]) => {
          const obj = {};
          if (items) {
            for (const [k, v] of items) {
              obj[k] = v;
            }
          }
          return obj;
        },
      },
      {name: 'jsonObjectItems$ebnf$1', symbols: []},
      {
        name: 'jsonObjectItems$ebnf$1$subexpression$1',
        symbols: ['jsonKeyValue', '_', {literal: ','}, '_'],
      },
      {
        name: 'jsonObjectItems$ebnf$1',
        symbols: [
          'jsonObjectItems$ebnf$1',
          'jsonObjectItems$ebnf$1$subexpression$1',
        ],
        postprocess: function arrpush(d) {
          return d[0].concat([d[1]]);
        },
      },
      {
        name: 'jsonObjectItems',
        symbols: ['jsonObjectItems$ebnf$1', 'jsonKeyValue'],
        postprocess: ([pairs, last]) => [...pairs.map(([kv]) => kv), last],
      },
      {
        name: 'jsonKeyValue',
        symbols: ['string', '_', {literal: ':'}, '_', 'jsonValue'],
        postprocess: ([key, _1, _2, _3, value]) => [key, value],
      },
      {name: 'jsonValue', symbols: ['number'], postprocess: id},
      {name: 'jsonValue', symbols: ['string'], postprocess: id},
      {name: 'jsonValue', symbols: ['bool'], postprocess: id},
      {name: 'jsonValue', symbols: ['jsonArray'], postprocess: id},
      {name: 'jsonValue', symbols: ['jsonObject'], postprocess: id},
      {name: 'primitive$subexpression$1', symbols: [{literal: 'Boolean'}]},
      {name: 'primitive$subexpression$1', symbols: [{literal: 'Number'}]},
      {name: 'primitive$subexpression$1', symbols: [{literal: 'Text'}]},
      {name: 'primitive$subexpression$1', symbols: [{literal: 'Element'}]},
      {name: 'primitive$subexpression$1', symbols: [{literal: 'RowEmpty'}]},
      {name: 'primitive$subexpression$1', symbols: [{literal: 'List'}]},
      {name: 'primitive$subexpression$1', symbols: [{literal: 'Record'}]},
      {
        name: 'primitive',
        symbols: ['primitive$subexpression$1'],
        postprocess: ([[{value}]]) => primitiveOf(value),
      },
      {
        name: 'tvar',
        symbols: ['ident'],
        postprocess: ([ident]) => ast.TTypeReference(ident),
      },
      {name: 'tlist$subexpression$1', symbols: ['listApplication']},
      {name: 'tlist$subexpression$1', symbols: ['listShorthand']},
      {name: 'tlist', symbols: ['tlist$subexpression$1'], postprocess: id2},
      {
        name: 'listApplication',
        symbols: [
          {literal: 'List'},
          {literal: '<'},
          '_',
          'type',
          '_',
          {literal: '>'},
        ],
        postprocess: ([List, labrack, _, type]) => ast.TList(type),
      },
      {
        name: 'listShorthand',
        symbols: ['type', {literal: '['}, {literal: ']'}],
        postprocess: ([type]) => ast.TList(type),
      },
      {
        name: 'trecord',
        symbols: ['rowSet'],
        postprocess: ([{fields, tail}]) =>
          tail ? ast.TRecord(fields, tail) : ast.TRecord(fields),
      },
      {
        name: 'tunion',
        symbols: [
          {literal: 'Union'},
          {literal: '<'},
          '_',
          'rowSet',
          '_',
          {literal: '>'},
        ],
        postprocess: ([Union, labrack, _, {fields, tail}]) =>
          tail ? ast.TUnion(fields, tail) : ast.TUnion(fields),
      },
      {name: 'tenum$ebnf$1', symbols: []},
      {
        name: 'tenum$ebnf$1',
        symbols: ['tenum$ebnf$1', 'commaSeparatedEnumPair'],
        postprocess: function arrpush(d) {
          return d[0].concat([d[1]]);
        },
      },
      {name: 'tenum$ebnf$2$subexpression$1', symbols: ['enumPair', '_']},
      {
        name: 'tenum$ebnf$2',
        symbols: ['tenum$ebnf$2$subexpression$1'],
        postprocess: id,
      },
      {
        name: 'tenum$ebnf$2',
        symbols: [],
        postprocess: function (d) {
          return null;
        },
      },
      {
        name: 'tenum',
        symbols: [
          {literal: 'Enum'},
          {literal: '<'},
          '_',
          {literal: '{'},
          '_',
          'tenum$ebnf$1',
          'tenum$ebnf$2',
          {literal: '}'},
          '_',
          {literal: '>'},
        ],
        postprocess: ([
          Enum,
          labrack,
          _1,
          lbr,
          _2,
          pairs,
          maybeLast,
          rbr,
          _3,
          rabrack,
        ]) => {
          const values = {};
          if (pairs) {
            for (const pair of pairs) {
              if (pair) values[pair[0]] = pair[1];
            }
          }
          if (maybeLast) {
            const last = maybeLast[0];
            values[last[0]] = last[1];
          }
          return ast.TEnum(values);
        },
      },
      {
        name: 'commaSeparatedEnumPair$subexpression$1',
        symbols: ['enumPair', '_', {literal: ','}, '_'],
      },
      {
        name: 'commaSeparatedEnumPair',
        symbols: ['commaSeparatedEnumPair$subexpression$1'],
        postprocess: ([[pair]]) => pair,
      },
      {
        name: 'enumPair',
        symbols: ['fieldName', '_', {literal: ':'}, '_', 'string'],
        postprocess: ([key, $1, $2, $3, value]) => [key, value],
      },
      {name: 'rowSet$subexpression$1$ebnf$1', symbols: []},
      {
        name: 'rowSet$subexpression$1$ebnf$1',
        symbols: ['rowSet$subexpression$1$ebnf$1', 'commaSeparatedPair'],
        postprocess: function arrpush(d) {
          return d[0].concat([d[1]]);
        },
      },
      {
        name: 'rowSet$subexpression$1$ebnf$2$subexpression$1$subexpression$1',
        symbols: ['tpair'],
      },
      {
        name: 'rowSet$subexpression$1$ebnf$2$subexpression$1$subexpression$1$subexpression$1$ebnf$1',
        symbols: [{literal: ','}],
        postprocess: id,
      },
      {
        name: 'rowSet$subexpression$1$ebnf$2$subexpression$1$subexpression$1$subexpression$1$ebnf$1',
        symbols: [],
        postprocess: function (d) {
          return null;
        },
      },
      {
        name: 'rowSet$subexpression$1$ebnf$2$subexpression$1$subexpression$1$subexpression$1',
        symbols: [
          {literal: '...'},
          'tvar',
          'rowSet$subexpression$1$ebnf$2$subexpression$1$subexpression$1$subexpression$1$ebnf$1',
        ],
      },
      {
        name: 'rowSet$subexpression$1$ebnf$2$subexpression$1$subexpression$1',
        symbols: [
          'rowSet$subexpression$1$ebnf$2$subexpression$1$subexpression$1$subexpression$1',
        ],
      },
      {
        name: 'rowSet$subexpression$1$ebnf$2$subexpression$1',
        symbols: [
          'rowSet$subexpression$1$ebnf$2$subexpression$1$subexpression$1',
          '_',
        ],
      },
      {
        name: 'rowSet$subexpression$1$ebnf$2',
        symbols: ['rowSet$subexpression$1$ebnf$2$subexpression$1'],
        postprocess: id,
      },
      {
        name: 'rowSet$subexpression$1$ebnf$2',
        symbols: [],
        postprocess: function (d) {
          return null;
        },
      },
      {
        name: 'rowSet$subexpression$1',
        symbols: [
          {literal: '{'},
          '_',
          'rowSet$subexpression$1$ebnf$1',
          'rowSet$subexpression$1$ebnf$2',
          {literal: '}'},
        ],
      },
      {
        name: 'rowSet',
        symbols: ['rowSet$subexpression$1'],
        postprocess: ([[lbr, _, pairs, maybeTail]]) => {
          return generateFieldsAndTail(pairs, maybeTail);
        },
      },
      {name: 'rowType$subexpression$1$ebnf$1', symbols: []},
      {
        name: 'rowType$subexpression$1$ebnf$1',
        symbols: ['rowType$subexpression$1$ebnf$1', 'commaSeparatedPair'],
        postprocess: function arrpush(d) {
          return d[0].concat([d[1]]);
        },
      },
      {
        name: 'rowType$subexpression$1$ebnf$2$subexpression$1$subexpression$1',
        symbols: ['tpair'],
      },
      {
        name: 'rowType$subexpression$1$ebnf$2$subexpression$1$subexpression$1$subexpression$1$ebnf$1',
        symbols: [{literal: ','}],
        postprocess: id,
      },
      {
        name: 'rowType$subexpression$1$ebnf$2$subexpression$1$subexpression$1$subexpression$1$ebnf$1',
        symbols: [],
        postprocess: function (d) {
          return null;
        },
      },
      {
        name: 'rowType$subexpression$1$ebnf$2$subexpression$1$subexpression$1$subexpression$1',
        symbols: [
          {literal: '...'},
          'tvar',
          'rowType$subexpression$1$ebnf$2$subexpression$1$subexpression$1$subexpression$1$ebnf$1',
        ],
      },
      {
        name: 'rowType$subexpression$1$ebnf$2$subexpression$1$subexpression$1',
        symbols: [
          'rowType$subexpression$1$ebnf$2$subexpression$1$subexpression$1$subexpression$1',
        ],
      },
      {
        name: 'rowType$subexpression$1$ebnf$2$subexpression$1',
        symbols: [
          'rowType$subexpression$1$ebnf$2$subexpression$1$subexpression$1',
          '_',
        ],
      },
      {
        name: 'rowType$subexpression$1$ebnf$2',
        symbols: ['rowType$subexpression$1$ebnf$2$subexpression$1'],
        postprocess: id,
      },
      {
        name: 'rowType$subexpression$1$ebnf$2',
        symbols: [],
        postprocess: function (d) {
          return null;
        },
      },
      {
        name: 'rowType$subexpression$1',
        symbols: [
          {literal: '{%'},
          '_',
          'rowType$subexpression$1$ebnf$1',
          'rowType$subexpression$1$ebnf$2',
          {literal: '%}'},
        ],
      },
      {
        name: 'rowType',
        symbols: ['rowType$subexpression$1'],
        postprocess: ([[lbr, _, pairs, maybeTail]]) => {
          const {fields, tail} = generateFieldsAndTail(pairs, maybeTail);

          return ast.constructRow({items: fields, tail: tail ?? ast.TRowEmpty});
        },
      },
      {
        name: 'commaSeparatedPair$subexpression$1',
        symbols: ['tpair', '_', {literal: ','}, '_'],
      },
      {
        name: 'commaSeparatedPair',
        symbols: ['commaSeparatedPair$subexpression$1'],
        postprocess: ([[pair]]) => pair,
      },
      {name: 'fieldName$subexpression$1', symbols: ['ident']},
      {name: 'fieldName$subexpression$1', symbols: ['string']},
      {
        name: 'fieldName',
        symbols: ['fieldName$subexpression$1'],
        postprocess: id2,
      },
      {name: 'tpair$ebnf$1', symbols: ['attributeSet'], postprocess: id},
      {
        name: 'tpair$ebnf$1',
        symbols: [],
        postprocess: function (d) {
          return null;
        },
      },
      {
        name: 'tpair',
        symbols: [
          'tpair$ebnf$1',
          'fieldName',
          '_',
          {literal: ':'},
          '_',
          'type',
        ],
        postprocess: ([attributes, name, $1, $2, $3, type]) => [
          name,
          applyAttributes(attributes, type),
        ],
      },
      {
        name: 'generic',
        symbols: [
          {literal: '<'},
          '_',
          'identList',
          '_',
          {literal: '>'},
          '_',
          {literal: '('},
          '_',
          'type',
          '_',
          {literal: ')'},
        ],
        postprocess: ([
          ,
          ,
          /*<*/ /* _ */ args /* _ */ /*>*/ /* _ */ /*(*/ /* _ */,
          ,
          ,
          ,
          ,
          ,
          type,
        ]) => {
          let result = type;
          for (let i = args.length - 1; i >= 0; i -= 1) {
            result = ast.TGeneric({arg: args[i], body: result});
          }
          return result;
        },
      },
      {name: 'identList$subexpression$1$ebnf$1', symbols: []},
      {
        name: 'identList$subexpression$1$ebnf$1',
        symbols: ['identList$subexpression$1$ebnf$1', 'commaSeparatedIdent'],
        postprocess: function arrpush(d) {
          return d[0].concat([d[1]]);
        },
      },
      {
        name: 'identList$subexpression$1',
        symbols: ['identList$subexpression$1$ebnf$1', 'ident'],
      },
      {
        name: 'identList',
        symbols: ['identList$subexpression$1'],
        postprocess: ([[idents, lastIdent]]) => {
          if (lastIdent) {
            return [...idents, lastIdent];
          } else {
            return idents;
          }
        },
      },
      {
        name: 'commaSeparatedIdent$subexpression$1',
        symbols: ['ident', '_', {literal: ','}, '_'],
      },
      {
        name: 'commaSeparatedIdent',
        symbols: ['commaSeparatedIdent$subexpression$1'],
        postprocess: ([[ident]]) => ident,
      },
      {
        name: 'qualifiedTVar',
        symbols: ['ident', {literal: '::'}, 'ident'],
        postprocess: ([pluginName /* :: */, , name]) =>
          wq.qualify(w.Plugins.name(pluginName), wq.typeName(name)),
      },
      {
        name: 'tconstructor',
        symbols: ['qualifiedTVar'],
        postprocess: ([qvar]) => ast.TTypeConstructor(qvar),
      },
      {
        name: 'tapplication',
        symbols: [
          'qualifiedTVar',
          '_',
          {literal: '<'},
          '_',
          'typeList',
          '_',
          {literal: '>'},
        ],
        postprocess: ([qvar /* _ */ /* < */ /* _ */, , , , args]) => {
          return ast.constructTypeApplication({
            con: qvar,
            args,
          });
        },
      },
      {
        name: 'tfunc$subexpression$1',
        symbols: ['funcArgs', '_', {literal: '=>'}, '_', 'type'],
      },
      {
        name: 'tfunc',
        symbols: ['tfunc$subexpression$1'],
        postprocess: ([[args /* _ */ /* => */ /* _ */, , , , returnType]]) => {
          let result = returnType;
          for (let i = args.length - 1; i >= 0; i -= 1) {
            result = ast.functionOf(args[i], result);
          }
          return result;
        },
      },
      {name: 'funcArgs$subexpression$1', symbols: ['safeArg']},
      {name: 'funcArgs$subexpression$1', symbols: ['parendTypeList']},
      {
        name: 'funcArgs',
        symbols: ['funcArgs$subexpression$1'],
        postprocess: ([[args]]) => {
          if (Array.isArray(args)) return args;
          return [args];
        },
      },
      {
        name: 'parendTypeList',
        symbols: [{literal: '('}, '_', 'typeList', '_', {literal: ')'}],
        postprocess: ([lp, _, typeList]) => {
          return typeList;
        },
      },
      {name: 'typeList$subexpression$1$ebnf$1', symbols: []},
      {
        name: 'typeList$subexpression$1$ebnf$1',
        symbols: ['typeList$subexpression$1$ebnf$1', 'commaSeparatedType'],
        postprocess: function arrpush(d) {
          return d[0].concat([d[1]]);
        },
      },
      {
        name: 'typeList$subexpression$1',
        symbols: ['typeList$subexpression$1$ebnf$1', 'safeArg'],
      },
      {
        name: 'typeList',
        symbols: ['typeList$subexpression$1'],
        postprocess: ([[types, lastType]]) => {
          if (lastType) {
            return [...types, lastType];
          } else {
            return types;
          }
        },
      },
      {
        name: 'commaSeparatedType$subexpression$1',
        symbols: ['safeArg', '_', {literal: ','}, '_'],
      },
      {
        name: 'commaSeparatedType',
        symbols: ['commaSeparatedType$subexpression$1'],
        postprocess: ([[type]]) => {
          return type;
        },
      },
      {name: 'safeArg$subexpression$1', symbols: ['nonFuncType']},
      {name: 'safeArg$subexpression$1', symbols: ['parenedFunc']},
      {name: 'safeArg', symbols: ['safeArg$subexpression$1'], postprocess: id2},
      {
        name: 'parenedFunc',
        symbols: [{literal: '('}, '_', 'tfunc', '_', {literal: ')'}],
        postprocess: ([lp, _, func]) => func,
      },
    ],
    ParserStart: 'typeMain',
  };
  if (typeof module !== 'undefined' && typeof module.exports !== 'undefined') {
    module.exports = grammar;
  } else {
    window.grammar = grammar;
  }
})();
